import React, { useState } from 'react';
import { CheckCircle2Icon, ClockIcon, UsersIcon } from 'lucide-react';
import { StatCard } from '../components/StatCard';
import { FollowUpQueue } from '../components/FollowUpQueue';
import { followUpLeads, type FollowUpLead } from '../data/followUps';
export function FollowUps() {
  const [leads, setLeads] = useState<FollowUpLead[]>(followUpLeads);
  const updateLead = (id: string, changes: Partial<FollowUpLead>) => setLeads(prev => prev.map(lead => lead.id === id ? {
    ...lead,
    ...changes
  } : lead));
  const completed = leads.filter(lead => lead.status === 'contacted').length;
  const pending = leads.filter(lead => lead.status === 'pending').length;
  const overdue = leads.filter(lead => lead.status === 'pending' && new Date(lead.nextFollowUp).getTime() < Date.now()).length;
  return <div className="space-y-4" data-id="element-750" data-mp="3qoje5ptb85k7">
      <div data-id="element-751" data-mp="3qqcb2de4fbf0">
        <h1 className="text-[22px] font-bold text-ink" data-id="element-752" data-mp="3vn2xrjkfl59e">Follow-ups</h1>
        <p className="mt-1 text-[13px] text-gray-500" data-id="element-753" data-mp="3vp72u4u2gab9">
          Manage daily borrower communications and campaign follow-ups.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-754" data-mp="1m6wwu1ebf7yd">
        <StatCard label="Total follow-ups today" value={String(leads.length)} caption="2 more than yesterday" icon={UsersIcon} data-id="element-755" data-mp="1m8honj98wcsj" />
        <StatCard label="Completed" value={String(completed)} caption="logged calls today" tone="success" icon={CheckCircle2Icon} data-id="element-756" data-mp="1w52v890wxvyh" />
        <StatCard label="Pending" value={String(pending)} caption={overdue > 0 ? `${overdue} overdue` : 'all on schedule'} tone="warn" icon={ClockIcon} data-id="element-757" data-mp="13h74rm1xt0a5" />
      </div>

      <FollowUpQueue leads={leads} onUpdateLead={updateLead} data-id="element-758" data-mp="1cehe31v72fcf" />
    </div>;
}